import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import {showAppLoader, hideAppLoader} from "app/Components/Shared/Loader/LoaderSlice";
import {prepareSameWindowUrlWithNavigateTo} from "app/utilities/StringHelpers/StringHelpers";
import Config from "app/Config";

export const getCouponTerms = createAsyncThunk('Coupons/GetCouponTerms', async (couponType, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const couponTerms = await ProviderManager.getProviderData("getCouponTerms", [couponType]);
    return couponTerms.Body;
  } catch (error) {
    return null;
  }
  finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

const couponTermsSlice = createSlice({
  name: 'couponTerms',
  initialState: {
  },
  reducers: {
  },
  extraReducers: {
    [getCouponTerms.fulfilled]: (state, action) => {
      const couponTermsUrl = action.payload;
      if (!couponTermsUrl){
        prepareSameWindowUrlWithNavigateTo(Config.staticWebSiteUrl);
      } else {
        prepareSameWindowUrlWithNavigateTo(`${Config.epiBaseUrl}${couponTermsUrl}`);
      }
    },
    [getCouponTerms.rejected]: (state, action) => {
      prepareSameWindowUrlWithNavigateTo(Config.staticWebSiteUrl);
    },
  }
});

export const {
} = couponTermsSlice.actions;

export default couponTermsSlice.reducer;
